import React from "react";
import { startCase } from "lodash";
import {
    OrderConsultationResultContainer,
    OrderConsultationResultList,
    OrderConsultationResultTitle,
} from "./OrderConsultationResult.styles";
import { OrderConsultationResultListItem } from "../orderConsultationResultListItem/OrderConsultationResultListItem";

/**
 * OrderConsultationResultProps
 */
interface OrderConsultationResultProps {
    status: string;
    data: any[];
    onNoteSave?: any;
    consultationTranslations: any;
    pageTranslations: any;
}

// Translation imports
import { enTranslations } from "../../../translations/en";
import { deTranslations } from "../../../translations/de";
import { ConsultationPageTranslations } from "../../../translations/types";
import { SupportedLanguage } from "../../../../../../core/translations/supportedLanguages";
import { useLanguage } from "../../../../../../core/translations/LanguageContext";


/**
 * OrderConsultationResult
 *
 * This component is a list of consultation results. It displays the consultation results that are
 * available or pending. There are two statuses: available and pending.
 */
export const OrderConsultationResult = ({
    status,
    data,
    onNoteSave,
    consultationTranslations,
    pageTranslations

}: OrderConsultationResultProps) => {


    console.log("Status: ", status);
    return (
        <OrderConsultationResultContainer>
            <OrderConsultationResultTitle>
                {status === 'pending' ? pageTranslations.pending : pageTranslations.available}
            </OrderConsultationResultTitle>
            <OrderConsultationResultList>
                {data && data.length > 0
                    ? data.map((item, index) =>
                          status === "pending" ? (
                              // For pending results, show details and no buttons
                              <OrderConsultationResultListItem
                                  key={index}
                                  title={item.specialty}
                                  complete={false}
                                  details={`Ordered at ${item.turn_ordered}`}
                                  allowNotes={false}
                                  turn_ordered={item.turn_ordered}
                                  summary={item.summary}
                                  consultationTranslations={consultationTranslations}
                                  pageTranslations={pageTranslations}
                              />
                          ) : (
                              // For available results, show the full details
                              <OrderConsultationResultListItem
                                  key={index}
                                  title={item.specialty}
                                  complete={true}
                                  details={item.findings}
                                  allowNotes={true}
                                  turn_ordered={item.turn_ordered}
                                  summary={item.summary}
                                  onNoteSave={onNoteSave}
                                  consultationTranslations={consultationTranslations}
                                  pageTranslations={pageTranslations}
                              />
                          )
                      )
                    : null}
            </OrderConsultationResultList>
        </OrderConsultationResultContainer>
    );
};
